import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import 'rxjs/add/operator/map';
@Injectable({
	providedIn: 'root'
})

export class AppServiceService {

	UnitList: any = [];
	public UnitListDatamyMethodSubject = new BehaviorSubject([]);
	FYearList: any = [];

	public productdata: any;
	public myMethodSubject = new BehaviorSubject('default');
	public currentTable = this.myMethodSubject.asObservable();

	public branddata: any;
	public brandmyMethodSubject = new BehaviorSubject('default');
	public brandcurrentTable = this.brandmyMethodSubject.asObservable();

	public manufacturerdata: any;
	public manufacturermyMethodSubject = new BehaviorSubject('default');
	public manufacturercurrentTable = this.manufacturermyMethodSubject.asObservable();

	public footerData: any;
	public footerDataSubject = new BehaviorSubject('default');
	public footerDataTable = this.footerDataSubject.asObservable();

	public DashboardData: any;
	public DashboardDatamyMethodSubject = new BehaviorSubject({});
	public DashboardDatacurrentTable = this.DashboardDatamyMethodSubject.asObservable();

	public DashboardLiveData: any;
	public DashboardLiveDatamyMethodSubject = new BehaviorSubject({});
	public DashboardLiveDatacurrentTable = this.DashboardLiveDatamyMethodSubject.asObservable();

	public UnitFyearData: any;
	public UnitFyearDatamyMethodSubject = new BehaviorSubject({});
	public UnitFyearDatacurrentTable = this.UnitFyearDatamyMethodSubject.asObservable();

	public unitInfo: any;

	public LastSelectedProductIndex: any = 0;
	public LastProductSearchValue: any = "";

	constructor(@Inject(HttpClient) private http: HttpClient) {
		this.http = http;
		this.OnDashboardDataLoad();
	}

	OnDashboardDataLoad() {
		this.DashboardData = {};
		this.DashboardDatamyMethodSubject = new BehaviorSubject({});
		this.DashboardDatacurrentTable = this.DashboardDatamyMethodSubject.asObservable();

		this.DashboardLiveData = {};
		this.DashboardLiveDatamyMethodSubject = new BehaviorSubject({});
		this.DashboardLiveDatacurrentTable = this.DashboardLiveDatamyMethodSubject.asObservable();

		this.UnitFyearData = {};
		this.UnitFyearDatamyMethodSubject = new BehaviorSubject({});
		this.UnitFyearDatacurrentTable = this.UnitFyearDatamyMethodSubject.asObservable();
	}

	f_chknum(p_value) {
		var Val = Number(p_value);
		if (Val) {
			return Val;
		}
		return 0;
	}

	getter() {
		this.unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
		var data = { "Unit_ID": this.unitInfo.Unit_ID };
		this.http.post(`/api/${this.unitInfo.Company_Code}/products/getProductList`, data)
			.subscribe(response => {
				this.productdata = response;
				this.setProductData(response);
			});
	}

	setProductData(data) {
		this.myMethodSubject.next(data);
	}

	getProductData() {
		return this.productdata;
	}

	setter() {
		return this.myMethodSubject.asObservable();
	}

	postServiceTest(url) {
		this.http.get(url)
			.subscribe(response => {
				return response;
			});
	}

	brandgetter() {
		this.http.get('/api/brands/GetBrandActiveList/' + 1)
			.subscribe(response => {
				this.branddata = response;
				this.setbrandData(response);
			});
	}

	setbrandData(data) {
		this.brandmyMethodSubject.next(data);
	}

	manufacturergetter() {
		this.http.get('/api/Manufacturers/getManufacturerslist/' + JSON.stringify({ "Unit_ID": this.unitInfo.Unit_ID }))
			.subscribe(response => {
				this.manufacturerdata = response;
				this.setmanufacturerData(response);
			});
	}

	getFooterDetails() {
		if (localStorage.getItem("permission")) {
			let info = JSON.parse(localStorage.getItem('permission'))[0];
			this.footerDataSubject.next(info);
		}
	}

	setmanufacturerData(data) {
		this.manufacturermyMethodSubject.next(data);
	}

	GetUnitFyearList() {
		return {
			UnitList: this.UnitList,
			FYearList: this.FYearList
		};
	}

	GetUnitList() {
		return this.UnitList;
	}

	Set_Sales_Dashboard_Detail() {
		this.DashboardDatamyMethodSubject.next(this.DashboardData);
	}

	Set_Sales_Dashboard_Detail_Live() {
		this.DashboardLiveDatamyMethodSubject.next(this.DashboardLiveData);
	}

	SetUnitFyearData() {
		this.UnitFyearDatamyMethodSubject.next(this.UnitFyearData);
	}

	Get_Sales_Dashboard_Detail() {
		this.unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
		const { CDN_Enabled, CDN_Domain, Company_Code, Unit_ID, Company_ID, CurrentFYear, _id } = this.unitInfo;
		let data = {
			'Company_ID': this.unitInfo.Company_ID,
			'Unit_ID': this.unitInfo.Unit_ID,
			"User_ID":(this.unitInfo.Roll_ID === 4 ? 0 : this.unitInfo._id),
			"Roll_ID": this.unitInfo.Roll_ID
		};

		this.http.get(`${CDN_Enabled ? "//" + CDN_Domain : ""}/api/${Company_Code}/SalesInvoices/Get_Sales_Dashboard_Detail`, {params: data})
			.subscribe((response: any) => {
				this.DashboardData = response;
				this.Set_Sales_Dashboard_Detail();
			})
	}

	Get_Sales_Dashboard_Detail_Live() {
		this.unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
		const { CDN_Enabled, CDN_Domain, Company_Code, Unit_ID, Company_ID, CurrentFYear, _id } = this.unitInfo;
		let data = {
			'Company_ID': this.unitInfo.Company_ID,
			'Unit_ID': this.unitInfo.Unit_ID,
			"User_ID": (this.unitInfo.Roll_ID === 4 ? 0 : this.unitInfo._id),
			"Roll_ID": this.unitInfo.Roll_ID
		};

		this.http.get(`${CDN_Enabled ? "//" + CDN_Domain : ""}/api/${Company_Code}/SalesInvoices/Get_Sales_Dashboard_Detail_Live`, {params: data})
			.subscribe((response: any) => {
				this.DashboardLiveData = response;
				this.Set_Sales_Dashboard_Detail_Live();
			})
	}

	async GetUnitFyearData(_id) {
		 console.log("hello from product service");
		let data = { "user_ID": _id };
		await this.http.post('api/users/getUnitData', data)
			.subscribe(async (response: any) => {
				this.UnitFyearData = response;
				this.UnitList = response.UnitList;
				this.FYearList = response.FyearList;
				this.UnitListDatamyMethodSubject.next(this.UnitList);
				let perm = JSON.parse(localStorage.getItem('permission'));
				if (perm && perm.length == 0) {
					return false;
				}
				if (this.UnitList.length > 0) {
					let selectedFYear: any;
					let currentUnit: any;
					if (this.f_chknum(perm[0].IsUnitChange) == 0) {
						currentUnit = this.UnitList.filter(xx => { return xx.IsDefault == 1 })[0];
						selectedFYear = this.FYearList.filter(xxx => { return xxx.Is_Current == 1 })[0];
					} else {
						currentUnit = this.UnitList.filter(xx => { return xx.Unit_ID == perm[0].Unit_ID })[0];
						selectedFYear = this.FYearList.filter(xxx => { return xxx.CurrentFYear == perm[0].CurrentFYear })[0];
					}
					let permission = JSON.parse(localStorage.getItem('permission'));
					permission[0].CurrentFYear = selectedFYear.CurrentFYear;
					permission[0].Current_Fyear_FromDate = selectedFYear.Fyear_FromDate;
					permission[0].Current_Fyear_ToDate = selectedFYear.To_Date;
					permission[0].Fyear = selectedFYear.FYear;
					permission[0].State_ID = currentUnit.State_ID;
					permission[0].Unit_GST_No = currentUnit.Unit_GST_No;
					permission[0].Unit_ID = currentUnit.Unit_ID;
					permission[0].Unit_Name = currentUnit.Unit_Name;
					permission[0].Unit_State_Code = currentUnit.State_Code;
					permission[0].Unit_City_Desc = currentUnit.City_Desc;
					permission[0].Unit_Address_1 = currentUnit.Unit_Address1;
					permission[0].Unit_Address_2 = currentUnit.Unit_Address2;
					permission[0].Unit_Address = currentUnit.Unit_Address;
					permission[0].Pincode_ID = currentUnit.Pincode_ID;
					permission[0].Is_POImport_Allow = currentUnit.Is_POImport_Allow;
					permission[0].TCS_Applicable = currentUnit.TCS_Applicable;
					permission[0].TCS_WithPan_Percentage = currentUnit.TCS_WithPan_Percentage;
					permission[0].TCS_WithoutPan_Percentage = currentUnit.TCS_WithoutPan_Percentage;
					permission[0].TCS_Invoice_Amount = currentUnit.TCS_Invoice_Amount;
					permission[0].Is_Sales_Return_Loose_Qty_Allow = currentUnit.Is_Sales_Return_Loose_Qty_Allow;
					permission[0].Is_Sales_Breakage_Loose_Qty_Allow = currentUnit.Is_Sales_Breakage_Loose_Qty_Allow;
					permission[0].Is_Flood_Cess_Allow = currentUnit.Is_Flood_Cess_Allow;
					permission[0].Flood_Cess_Percentage = currentUnit.Flood_Cess_Percentage;
					permission[0].Flood_Cess_Applied_On = currentUnit.Flood_Cess_Applied_On;
					permission[0].Max_Disc_Per = currentUnit.Max_Disc_Per;
					permission[0].Manufacturer_Warehouse_Flag = currentUnit.Manufacturer_Warehouse_Flag;
					permission[0].Warehouse_IDs = currentUnit.Warehouse_IDs;
					permission[0].Is_Sales_Scheme_Allow = currentUnit.Is_Sales_Scheme_Allow;
					permission[0].IS_HO = currentUnit.IS_HO;
					permission[0].TDS_WithPan_Percentage = currentUnit.TDS_WithPan_Percentage;
					permission[0].TDS_WithoutPan_Percentage = currentUnit.TDS_WithoutPan_Percentage;
					permission[0].Expiry_Deduction = currentUnit.Expiry_Deduction;
					permission[0].Is_GRN_Hold = currentUnit.Is_GRN_Hold;
					permission[0].Is_WST_Hold = currentUnit.Is_WST_Hold;
					permission[0].Is_SR_Hold = currentUnit.Is_SR_Hold;
					permission[0].Is_SBAE_Hold = currentUnit.Is_SBAE_Hold;
					permission[0].Fyear_FromDate = selectedFYear.Fyear_FromDate;
					permission[0].Fyear_ToDate = selectedFYear.Fyear_ToDate;
					permission[0].Fyear_Is_Current = selectedFYear.Is_Current;
					permission[0].Fyear_Locked = selectedFYear.Locked;
					permission[0].MDM_Domain_Name = currentUnit.MDM_Domain_Name;
					permission[0].MDM_Login_Name = currentUnit.MDM_Login_Name;
					permission[0].MDM_Password = currentUnit.MDM_Password;
					permission[0].MDM_Distributor_Code = currentUnit.MDM_Distributor_Code;
					permission[0].uvalue = currentUnit.uvalue;
					permission[0].AES_DEC = currentUnit.AES_DEC;
					permission[0].CDN_Enabled = currentUnit.CDN_Enabled;
					permission[0].CDN_Domain = currentUnit.CDN_Domain;
					permission[0].Bank_Charges = currentUnit.Bank_Charges;
					permission[0].BrkExpAutoPostDays = currentUnit.BrkExpAutoPostDays;
					permission[0].UnitCount = currentUnit.UnitCount;
					permission[0].DGS_Vendor_ID = currentUnit.DGS_Vendor_ID;
					permission[0].ShelfExpDay = currentUnit.ShelfExpDay;
					permission[0].USER_PICK_WAREHOUSE = permission[0].USER_PICK_WAREHOUSE;
					permission[0].EInvoice_Comp_Code = currentUnit.EInvoice_Comp_Code;
					permission[0].STATUS_URL = currentUnit.STATUS_URL;
					permission[0].VPA = currentUnit.VPA;
					permission[0].MC = currentUnit.MC;
					permission[0].Mode = currentUnit.Mode;
					permission[0].pgMerchantId = currentUnit.pgMerchantId;
					permission[0].secretKey = currentUnit.secretKey;
					permission[0].Is_CNDN_CUS_ROUNDOFF = currentUnit.Is_CNDN_CUS_ROUNDOFF;
					permission[0].ERP_Version = currentUnit.ERP_Version;
					permission[0].Stockist_ID = currentUnit.Stockist_ID;
					permission[0].Shelf_Life = currentUnit.Shelf_Life;
					permission[0].ALLOW_DMY_PRODUCT_EXPIRY_FORMAT = currentUnit.ALLOW_DMY_PRODUCT_EXPIRY_FORMAT;
					permission[0].BUCKET_NAME = currentUnit.BUCKET_NAME;
					permission[0].Unit_EmailID = currentUnit.Unit_EmailID;
					permission[0].EnableWhatsApp = currentUnit.EnableWhatsApp;
					permission[0].FYear1 = selectedFYear.FYear1;
					permission[0].Discount_Reversal = currentUnit.Discount_Reversal;
					// permission[0].DB_Name = currentUnit.DB_Name;
					//permission[0].Invoice_Tracking_Picklistwise_flag = currentUnit.Invoice_Tracking_Picklistwise_flag;

					localStorage.setItem('permission', JSON.stringify(permission));

					if(!window.location.hash){
						this.Get_Sales_Dashboard_Detail();
						this.Get_Sales_Dashboard_Detail_Live();
					}
				}
				this.SetUnitFyearData();
			})
	}

	setLastSelectedProductIndex(ProductIndex) {
		this.LastSelectedProductIndex = ProductIndex;
	}

	setLastProductSearchValue(SearchValue) {
		this.LastProductSearchValue = SearchValue;
	}
}